import mapColors from './map-colors';
var colorCollection = [{
  key: 'pink',
  color: '#b72d82'
}, {
  key: 'red',
  color: '#b92d2d'
}, {
  key: 'orange',
  color: '#e47130'
}, {
  key: 'yellow',
  color: '#b7a72d'
}, {
  key: 'green',
  color: '#7eb828'
}, {
  key: 'teal',
  color: '#28b8aa'
}, {
  key: 'cyan',
  color: '#2db7a7'
}, {
  key: 'blue',
  color: '#2d81b7'
}, {
  key: 'indigo',
  color: '#68479e'
}, {
  key: 'purple',
  color: '#622db7'
}];
var colors = mapColors(colorCollection);
export default colors;
export { colorCollection };